<div class="page-container">
  <button *ngIf="isLoggedIn" class="copy-link-btn" type="button" (click)="copyLink()">
    <svg *ngIf="!linkCopied" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/>
      <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/>
    </svg>
    <svg *ngIf="linkCopied" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
      <polyline points="20 6 9 17 4 12"/>
    </svg>
    {{ linkCopied ? 'Copied!' : 'Copy Link' }}
  </button>
  <h1 *ngIf="title" class="page-title">{{ title }}</h1>
  <p *ngIf="body" class="page-body">{{ body }}</p>
  <div *ngIf="loading">Loading...</div>
  <div *ngIf="!loading && creators.length === 0">No creators selected.</div>
  <div class="tiles-container" *ngIf="!loading && creators.length > 0"
       (dragover)="onGridDragOver($event)"
       (dragleave)="onGridDragLeave($event)"
       (drop)="onGridDrop($event)">
    <ng-container *ngFor="let creator of creators; let i = index">
      <div class="tile-placeholder" *ngIf="dropIndex === i"></div>
      <div class="tile-wrap"
           [class.drag-ghost]="dragIndex === i"
           [attr.draggable]="isLoggedIn ? true : null"
           (dragstart)="onTileDragStart($event, i)"
           (dragend)="onDragEnd()">
        <app-creator-tile [roster]="creator" [removable]="isLoggedIn" (remove)="removeCreator($event)"></app-creator-tile>
      </div>
    </ng-container>
    <div class="tile-placeholder" *ngIf="dropIndex === creators.length"></div>
  </div>
</div>
